import { ReloadOutlined } from '@ant-design/icons'
import { t } from 'i18next'
import React from 'react'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import { Form, Tooltip } from 'antd'
import KeyFigureInput from '../../../../../../../components/inputs/KeyFigureInput'
import { RowType } from '../../../../../../../redux/context/customReports/typesVariable'

const KeyfigureId = () => {
  const form = useFormInstance()
  const keyFigureId = Form.useWatch('keyFigureId', form)

  const updateTranslations = (id?: number) => {
    form.setFieldsValue({
      nameFi: t(`keyFigureStatement:${id}`, {
        lng: 'fi'
      }),
      nameEn: t(`keyFigureStatement:${id}`, {
        lng: 'en'
      }),
      nameSv: t(`keyFigureStatement:${id}`, {
        lng: 'sv'
      })
    })
  }

  return (
    <Form.Item
      key={RowType.keyFigure}
      name="keyFigureId"
      rules={[{ required: true, message: t('global:required-field') }]}
      label={
        <div>
          {t('global:keyFigure')}
          <Tooltip title={t('customReportPage:updateKeyfigureTranslations')}>
            <ReloadOutlined
              style={{ marginLeft: 5, color: '#0225a1', fontSize: 14 }}
              onClick={() => {
                updateTranslations(keyFigureId)
              }}
            />
          </Tooltip>
        </div>
      }
    >
      <KeyFigureInput />
    </Form.Item>
  )
}

export default KeyfigureId
